import { motion } from "framer-motion";
import heroImage from "../assets/images/data/About-us-header.jpg";
import { Helmet } from 'react-helmet-async';

const HeroSection = () => {
  return (
    <section className="w-full">
      <Helmet>
        <title>About Us | S Infinite Express</title>
        <meta
          name="description"
          content="S Infinite Express is India's trusted logistics partner with 11+ years of experience in PTL, FTL, warehousing, and express shipping solutions."
        />
        <meta
          name="keywords"
          content="About S Infinite Express, logistics company India, PTL, FTL, warehousing, express delivery, supply chain solutions"
        />
        <meta property="og:title" content="About Us | S Infinite Express" />
        <meta
          property="og:description"
          content="Explore the journey, mission, and vision of S Infinite Express — delivering logistics excellence across India."
        />
        <meta property="og:url" content="https://sinfiniteexpress.com/about-us" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://sinfiniteexpress.com/about-us" />
      </Helmet>

      {/* Hero Image */}
      <div
        className="relative h-[40vh] md:h-[30vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute bottom-[-1.75rem] left-6 md:left-16 bg-[#fff44f] px-6 py-3 md:px-8 md:py-4 shadow-lg">
          <h1 className="text-[#211f57] text-xl md:text-3xl font-extrabold">
            About us
          </h1>
        </div>
      </div>

      {/* Text + Cards Section */}
      <div className="bg-gradient-to-br from-yellow-50 via-white to-red-50 pt-20 md:pt-28 pb-12 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-start">
          {/* About Description */}
          <div className="text-gray-800 text-base md:text-lg leading-relaxed space-y-5">
            <p>
              <strong>S Infinite Express</strong> is one of India’s leading logistics and supply chain solution providers, backed by <strong>22+ years of proven experience</strong> in delivering speed, precision, and service excellence.
            </p>
            <p>
              Our tech-enabled logistics ecosystem covers <strong>PTL, FTL, express delivery, global freight forwarding</strong>, and <strong>smart warehousing</strong> — ensuring reliable and cost-effective movement of goods across the country and beyond.
            </p>
            <p>
              We proudly serve businesses across <strong>FMCG, Healthcare, Apparel, Electronics, Automotive, Retail</strong>, and <strong>Engineering</strong> industries, tailoring solutions that optimize delivery timelines and drive business outcomes.
            </p>
          </div>

          {/* Mission & Vision Cards */}
          <div className="space-y-6">
            {/* Mission Card */}
            <motion.div
              className="group relative bg-white p-6 border border-gray-200 rounded-md shadow transition hover:bg-gradient-to-r from-[#fff44f] via-[#fff86f] to-[#fffcb0] hover:shadow-lg"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="absolute left-0 top-0 h-full w-[6px] bg-[#fff44f] rounded-l-md"></div>
              <h3 className="text-xl font-bold text-[#211f57] mb-2 group-hover:text-[#211f57] transition">
                Mission
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed group-hover:text-gray-700 transition">
                "To be the most trusted logistics partner, delivering seamless, technology-driven
                supply chain solutions across India and globally — empowering our clients’ growth while
                contributing to the nation’s logistics excellence."
              </p>
            </motion.div>

            {/* Vision Card */}
            <motion.div
              className="group relative bg-white p-6 border border-gray-200 rounded-md shadow transition hover:bg-gradient-to-r from-[#fff44f] via-[#fff86f] to-[#fffcb0] hover:shadow-lg"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <div className="absolute left-0 top-0 h-full w-[6px] bg-[#fff44f] rounded-l-md"></div>
              <h3 className="text-xl font-bold text-[#211f57] mb-2 group-hover:text-[#211f57] transition">
                Vision
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed group-hover:text-gray-700 transition">
                "We are committed to building a future-ready logistics ecosystem by embracing innovation,
                ensuring reliability, and fostering a people-first culture. Through proactive service,
                zero-compromise delivery standards, and aligned operational excellence, we strive to exceed
                customer expectations at every step."
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
